// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__2tH-3","info":"Note_info__2iW5r","note":"Note_note__2vefR","actions":"Note_actions__1g9Ob"};